import HeaderButtons from "components/restaurants/HeaderButtons"
import styles from "./PageHeader.module.scss"

interface PageHeaderProps {
  name?: string | JSX.Element
  helpLink?: string
}

const PageHeader = ({ name, helpLink }: PageHeaderProps) => {
  return (
    <div className={styles.pageHeader}>
      <h3 className={styles.title}>{name}</h3>
      <HeaderButtons helpLink={helpLink} />
    </div>
  )
}

export default PageHeader
